<template>

  <footer>

    <div class="footerStrip">

      <div class="horizon2020">
        <a href="https://research-and-innovation.ec.europa.eu/funding/funding-opportunities/funding-programmes-and-open-calls/horizon-2020_en" target="_blank"> <img src="../../static/ue.jpg" alt="European Union"/> </a>
        <div>EOSC-synergy receives funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement	No 857647.</div>
      </div>

      <div class="license">
        <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank"> <img src="../../static/by.png" alt="Creative Commons BY 4.0"/> </a>
        <div>Unless otherwise indicated, all materials created by the EOSC-synergy consortium are licensed under a Creative Commons Attribution	4.0 International License.</div>
      </div>

      <div class="links">
        <router-link to="/privacy-policy" class="linkInPDF">Privacy Policy</router-link>
        <router-link to="/terms-use" class="linkInPDF">Terms of Service</router-link>
        <a href="https://www.eosc-synergy.eu/news-and-events" target="_blank" class="linkInPDF">News & Events</a>
        <router-link to="/version" class="linkInPDF">Release Info</router-link>
      </div>

    </div>

    <div class="footerBottom">
      <a href="https://www.eosc-synergy.eu" target="_blank" class="linkInPDF"> <img class="eosc-synergy-logo" src="../../static/eosc-synergy.png" alt="EOSC Synergy"/> </a>
      <a class="back-to-top hideInPDF" href="javascript:void(0)" @click="backToTop()"> <i class="fa fa-arrow-up" aria-hidden="true"></i> Back to top </a>
    </div>

	</footer>

</template>

<script>

  export default {
    data() {
      return {}
    },
    methods: {
      backToTop(){ $("html, body").animate({scrollTop: 0}); }
    }
  }

</script>

<style scoped>

  .footerStrip {
    display: grid;
    grid-template-columns: minmax(230px, 1fr) minmax(230px, 1fr) 1fr;
    column-gap: 4%;
    padding: 40px 10%;
    margin-bottom: 5px;
    background-color: #c9d22a;

    .horizon2020, .license {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      img {
        height: 80px;
        margin-bottom: 20px;
      }
    }

    .links {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      a {
        width: min(300px, 100%);
        line-height: 2.3em;
        color: #42697a;
        padding-left: 10px;
        border-top: 1px solid #343434;
      }
      a:last-child { border-bottom: 1px solid #343434; }
    }
  }

  @media (max-width: 1300px) {
    .footerStrip {
      padding: 40px 5%;
    }
  }

  @media (max-width: 760px) {
    .footerStrip {
      grid-template-rows: auto auto auto;
      grid-template-columns: auto;
      row-gap: 40px;
      padding: 30px 5%;
      .links {
        align-items: center;
        text-align: center;
      }
    }

  }

  .footerBottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 10px;
    .eosc-synergy-logo {
      width: 200px;
      padding: 1em 0;
    }
    .back-to-top:hover {
      color: #3472F7;
      text-decoration: underline;
    }
  }

</style>
